export default "__VITE_ASSET__DgXHLmj7__"